function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.43497 14.3266C7.89132 13.7851 7.92432 12.9355 8.50846 12.4312C9.09235 11.9271 10.009 11.9577 10.5529 12.4994L14.6418 16.5737C15.1862 17.1158 15.153 17.9654 14.5689 18.469C13.9845 18.9738 13.0683 18.9425 12.5244 18.4011L8.43497 14.3266Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.02684 16.5191C5.48295 15.977 5.51618 15.1276 6.10054 14.6233C6.68468 14.119 7.60019 14.1494 8.14407 14.6919L12.2344 18.7662C12.7783 19.3078 12.7451 20.1574 12.1616 20.6606C11.5765 21.1647 10.661 21.135 10.1171 20.5929L6.02684 16.5191Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.1551 13.5219C14.5605 14.0141 13.6478 13.9674 13.116 13.4167C12.586 12.8659 12.6356 12.0196 13.2291 11.5266L17.7042 7.81422C18.2981 7.32119 19.2108 7.36828 19.7421 7.91909C20.2738 8.46985 20.2225 9.31617 19.629 9.8092L15.1551 13.5219Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.4685 15.7954C16.8748 16.288 15.9611 16.241 15.4299 15.6902C14.8991 15.1392 14.949 14.2929 15.5436 13.7999L20.0194 10.0904C20.614 9.59735 21.5261 9.64486 22.0578 10.1959C22.5897 10.7462 22.5389 11.5921 21.9452 12.0851L17.4685 15.7954Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.4499 7.19622C15.0216 7.71269 15.0347 8.56163 14.4775 9.09198C13.921 9.62278 13.0055 9.63405 12.433 9.11754L8.12903 5.23746C7.5566 4.72164 7.54443 3.87251 8.10025 3.34215C8.65723 2.81179 9.57228 2.79986 10.1442 3.3161L14.4499 7.19622Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.7351 4.89967C17.3071 5.41615 17.3197 6.26571 16.7634 6.79586C16.2064 7.32621 15.2902 7.3375 14.7183 6.82254L10.4164 2.93681C9.84442 2.42099 9.83084 1.57143 10.3872 1.04063C10.9442 0.510273 11.8597 0.498999 12.4316 1.01458L16.7351 4.89967Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.77545 8.32926C8.35701 7.82213 9.27252 7.84838 9.81991 8.38694C10.3666 8.92663 10.3381 9.77624 9.7569 10.2823L5.39276 14.1018C4.81167 14.6087 3.89498 14.5831 3.34759 14.0441C2.80231 13.5044 2.82946 12.6557 3.41101 12.1488L7.77545 8.32926Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.40293 6.1145C5.98543 5.60692 6.90071 5.63251 7.4481 6.17217C7.99479 6.71187 7.96671 7.5606 7.38514 8.06752L3.01281 11.8838C2.43031 12.3907 1.51502 12.3646 0.967868 11.8261C0.420945 11.2868 0.448562 10.4377 1.03059 9.93076L5.40293 6.1145Z",
  fill: "white"
});

var SvgWhoWeAre = function SvgWhoWeAre(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhoWeAre, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/who-we-are.688b2934.svg";
export { ForwardRef as ReactComponent };